<template>
  <dl class="item-list" :class="{'dot':dot}">
    <dt v-show="title !== ''" :class="{'icon':titleIcon}">{{title}}</dt>
    <dd v-for="(item, index) in list" :key="index">{{item}}</dd>
  </dl>
</template>

<script>
export default {
  name: 'item-list',
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    dot: {
      type: Boolean,
      default: true
    },
    titleIcon: {
      // title为空时，titleIcon无效
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.item-list {
  color: $ucar_font_color;
  dt {
    font-size: $ucar_font_h4;
    position: relative;
    margin-bottom: 10px;
    line-height: 50px;
    font-weight: 700;
    &.icon {
      padding-left: 40px;
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 13px;
        width: 24px;
        height: 24px;
        background: url("../assets/icon_plus.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  &.dot {
    dd {
      font-size: $ucar_font_h6;
      color: $ucar_font_color;
      position: relative;
      padding-left: 30px;
      min-height: 50px;
      line-height: 50px;
      &::before {
        position: absolute;
        display: block;
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: $ucar_font_color;
        left: 0;
        top: 20px;
      }
    }
  }
}
</style>
